module.exports = __webpack_public_path__ + "static/media/launch_anchorage_3.c8bd621e.svg";